import * as React from 'react';
import sanitizeHtml from 'sanitize-html';

const ListItem = ({ post }) => {
	return (
		<div href={post.permalink} className="pfa-search-item">
			<div className="pfa-search-item__subtitle">{post.post_type_label}</div>
			<a
				className="pfa-search-item__link"
				href={post.permalink}
				dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }}
			></a>
		</div>
	);
};

ListItem.displayName = 'ListItem';

export default ListItem;
